import { IStorage } from '../interfaces/storage'

const createWebStorage = (storageType: Storage): IStorage => ({
  async clear() {
    storageType.clear()
  },
  async set(key: string, value: unknown) {
    storageType.setItem(key, JSON.stringify(value))
  },
  async get(key: string) {
    const item = storageType.getItem(key)
    if (!item) return undefined
    try {
      return JSON.parse(item)
    } catch {
      return item
    }
  },
  async remove(key: string) {
    storageType.removeItem(key)
  },
  async listen<TValue = unknown>(
    key: string,
    callback: (newValue: TValue, oldValue: TValue) => void
  ) {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key !== key) return
      
      let newValue: TValue | undefined
      let oldValue: TValue | undefined
      
      try {
        newValue = e.newValue ? JSON.parse(e.newValue) : undefined
      } catch {
        newValue = e.newValue as TValue
      }
      
      try {
        oldValue = e.oldValue ? JSON.parse(e.oldValue) : undefined
      } catch {
        oldValue = e.oldValue as TValue
      }
      
      callback(newValue as TValue, oldValue as TValue)
    }
    
    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  },
})

export const LocalStorage = createWebStorage(localStorage)
export const SessionStorage = createWebStorage(sessionStorage)